import React from 'react';
import { Button, Stack } from '@mui/material';
import type { VoiceVisualState } from './GreeningVoiceVisualizer';

interface Props {
  state: VoiceVisualState;
  held: 'listening' | 'speaking' | null;
  onListen: () => void;
  onStopListen: () => void;
  onToggleHold: () => void;
  /** Só a pausa. Ouvir análise não envia pergunta. */
  listenOnly?: boolean;
}

export const TALK_GRADIENT = 'linear-gradient(135deg, #009053 0%, #2B92AC 100%)';

export const greeningTalkButtonSx = {
  color: '#fff',
  backgroundImage: TALK_GRADIENT,
  boxShadow: 'none',
  '&:hover': {
    backgroundImage: TALK_GRADIENT,
    filter: 'brightness(1.06)',
  },
  '&.Mui-disabled': {
    color: '#fff',
    backgroundImage: TALK_GRADIENT,
    opacity: 0.85,
  },
};

export function GreeningVoiceControls({
  state,
  held,
  onListen,
  onStopListen,
  onToggleHold,
  listenOnly = false,
}: Props) {
  const micOpen = state === 'listening' || state === 'speech_detected' || held === 'listening';
  const canHold = listenOnly
    ? state === 'speaking' || state === 'paused' || held === 'speaking'
    : micOpen || state === 'speaking' || state === 'paused';
  return (
    <Stack direction="row" spacing={1.25} sx={{ mt: 1, mx: 1 }}>
      {listenOnly ? null : !micOpen ? (
        <Button
          type="button"
          variant="contained"
          disableElevation
          onClick={onListen}
          disabled={state === 'processing' || state === 'requesting_permission' || state === 'paused'}
          sx={{ ...greeningTalkButtonSx, flex: 1 }}
        >
          Ativar microfone
        </Button>
      ) : (
        <Button type="button" variant="contained" disableElevation onClick={onStopListen} sx={{ ...greeningTalkButtonSx, flex: 1 }}>
          Enviar fala
        </Button>
      )}
      <Button type="button" variant="contained" disableElevation onClick={onToggleHold} disabled={!canHold} sx={{ ...greeningTalkButtonSx, flex: 1 }}>
        {state === 'paused' ? 'Continuar' : 'Pausar'}
      </Button>
    </Stack>
  );
}
